import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ provider }) => {
  return {
    config_empId: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    isDriverOrDefault: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    getActionIcons: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    newUI: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
